import { DisplayedPasswordGroupListItem } from "./DisplayedPasswordGroupListItem";

export class DisplayedPasswordGroupListResult {
    groups: DisplayedPasswordGroupListItem[] = [];
    totalResults: number = 0;
}